module.exports = __webpack_public_path__ + "static/media/logo_white.02f58651.png";


//////////////////
// WEBPACK FOOTER
// ./src/brand/logo_white.png
// module id = 725
// module chunks = 0